const Fetcher = require('od-modules/utils/fetcher');
const paymentUtils = require('../../bags_and_seats/payment_utils/payment.utils');
const CREDIT_CARD_COLLECTION_METHOD = 'CREDITCARD';
const BOOKING_STATUS = {
    BOOKING_CONFIRMED: 'BOOKING_CONFIRMED',
    BOOKING_PENDING: 'BOOKING_PENDING',
    BOOKING_PAYMENT_RETRY: 'BOOKING_PAYMENT_RETRY',
    BOOKING_REPRICING: 'BOOKING_REPRICING',
    BOOKING_REJECTED: 'BOOKING_REJECTED',
    BOOKING_ERROR: 'BOOKING_ERROR',
    BOOKING_RETAINED: 'BOOKING_RETAINED',
    BOOKING_USER_INTERACTION_NEEDED: 'BOOKING_USER_INTERACTION_NEEDED',
};

const getUrlPrefix = Odigeo.Settings.getProperty('shoppingBasketServiceUrlFormatter');

const parseAvailableCreditCards = (availableCollectionMethodsResponse) => {
    const availableCollectionsMethods = Odigeo._.get(availableCollectionMethodsResponse, 'availableCollectionMethods', []);
    return availableCollectionsMethods.filter((element) => element.method === CREDIT_CARD_COLLECTION_METHOD);
};

module.exports = Backbone.Model.extend({
    initialize() {
        this.paymentUtils = paymentUtils;
    },
    getShoppingBasketId() {
        const shoppingBasketId = this.get('shoppingBasketId');
        return shoppingBasketId || this.createShoppingBasket()
            .then((shoppingBasketId) => shoppingBasketId)
            .catch(this.trigger.bind(this, 'shoppingBasketError', {customFeedback: this.get('isCheckIn'), genericError: true}));
    },
    setBundleId(bundleId) {
        this.set('bundleId', bundleId);
    },
    setBuyerInfo(buyerInfo) {
        this.set('buyerInfo', buyerInfo);
    },
    setShoppingBasketId(shoppingBasketId) {
        this.set('shoppingBasketId', shoppingBasketId);
    },
    createShoppingBasket() {
        const url = `${getUrlPrefix('create')}/${this.get('bundleId')}`;
        return Fetcher.get(url).json()
            .then((response) => {
                this.set('shoppingBasketId', response.shoppingBasketId);
                return response.shoppingBasketId;
            });
    },
    emptyShoppingBasket() {
        const url = `${getUrlPrefix('empty')}/${this.get('shoppingBasketId')}`;
        return Fetcher.post(url).json();
    },
    requestAddProductToShoppingBasket(productId) {
        return (this.get('shoppingBasketId')
            ? this.emptyShoppingBasket()
            : this.createShoppingBasket())
            .then(this.addProductToShoppingBasket.bind(this, productId))
            .catch(this.trigger.bind(this, 'shoppingBasketError', {customFeedback: this.get('isCheckIn'), genericError: true}));
    },
    addProductToShoppingBasket(productId) {
        const url = `${getUrlPrefix('addproduct')}/${this.get('shoppingBasketId')}/${productId}/${this.get('productType')}`;
        return Fetcher.post(url).json()
            .then(() => this.getAvailableCreditCards());
    },
    getAvailableCreditCards() {
        const url = `${getUrlPrefix('getavailablecollectionmethods')}/${this.get('shoppingBasketId')}`;
        return Fetcher.post(url, this.get('buyerInfo')).json()
            .then(parseAvailableCreditCards)
            .then(this.trigger.bind(this, 'setPaymentOptions'))
            .catch(this.trigger.bind(this, 'shoppingBasketError', {customFeedback: this.get('isCheckIn'), genericError: true}));
    },
    setCardData(paymentDetails) {
        this.paymentUtils.setCardData(paymentDetails);
    },
    checkout(options = {}) {
        const paymentDetails = paymentUtils.getPaymentDetails();
        const creditCardDetails = Odigeo._.get(paymentDetails, 'creditCardDetails') || {};
        const paymentMethod = Odigeo._.get(paymentDetails, 'method');
        const data = {
            paymentMethod,
            creditCardDetails: {
                token: creditCardDetails.paymentInstrumentToken,
                typeCode: creditCardDetails.typeCode,
            },
        };

        const url = `${getUrlPrefix('checkout')}/${this.get('shoppingBasketId')}`;
        return Fetcher.post(url, data).json()
            .then((response) => {
                this.onCheckoutSuccess(response, options);
            })
            .catch(this.trigger.bind(this, 'shoppingBasketError', options));
    },
    onCheckoutSuccess(checkoutResponse, options) {
        if (Odigeo._.isEmpty(checkoutResponse) || Odigeo._.get(checkoutResponse, 'errors')) {
            this.trigger('shoppingBasketError', options);
        } else {
            const status = Odigeo._.get(checkoutResponse, 'status');
            switch (status) {
                case BOOKING_STATUS.BOOKING_CONFIRMED:
                    this.trigger('confirm', options);
                    break;
                case BOOKING_STATUS.BOOKING_USER_INTERACTION_NEEDED:
                    this.trigger('userInteractionNeeded', checkoutResponse);
                    break;
                case BOOKING_STATUS.BOOKING_PAYMENT_RETRY:
                    this.trigger('paymentRetry', options);
                    break;
                case BOOKING_STATUS.BOOKING_REJECTED:
                case BOOKING_STATUS.BOOKING_PENDING:
                case BOOKING_STATUS.BOOKING_REPRICING:
                case BOOKING_STATUS.BOOKING_RETAINED:
                case BOOKING_STATUS.BOOKING_ERROR:
                default:
                    this.trigger('shoppingBasketError', options);
                    break;
            }
        }
    },
});
